// extracted by mini-css-extract-plugin
export default {"container":"logo_container__x1LAD","square":"logo_square__Rp3mE","close":"logo_close__j+FQN"};